import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TextureSimilarityFinder from './TextureSimilarityFinder';
import { mockTextures } from '../lib/mockupData';

const SimilarityFinderPage = () => {
  const [textures, setTextures] = useState([]);
  const navigate = useNavigate();
  
  useEffect(() => {
    // In a real application, you would fetch this data from an API
    // For this example, we're using mock data
    setTextures(mockTextures);
  }, []);
  
  return (
    <div className="similarity-page">
      <header className="similarity-header">
        <div className="header-content">
          <h1>Texture Similarity Finder</h1>
          <nav>
            <button onClick={() => navigate('/')}>← Torna alla galleria</button>
          </nav>
        </div>
      </header>
      
      <div className="similarity-container">
        <p className="intro-text">
          Questo strumento permette di trovare texture simili in base a vari criteri come colore, tag tattili,
          tag estetici, tag tecnici, materiale e categoria. Regola i pesi per dare più importanza 
          ad alcune caratteristiche rispetto ad altre.
        </p>
        
        {textures.length > 0 ? (
          <TextureSimilarityFinder textures={textures} />
        ) : (
          <div className="loading">Caricamento textures in corso...</div>
        )}
      </div>
      
      <style jsx>{`
        .similarity-page {
          min-height: 100vh;
          background-color: #f5f5f5;
        }
        
        .similarity-header {
          background-color: #2c3e50;
          color: white;
          padding: 20px 0;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        
        .header-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .header-content h1 {
          margin: 0;
          font-size: 24px;
          font-weight: 500;
        }
        
        .header-content button {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 16px;
          padding: 8px 0;
        }
        
        .header-content button:hover {
          text-decoration: underline;
        }
        
        .similarity-container {
          max-width: 1200px;
          margin: 30px auto;
          padding: 0 20px;
        }
        
        .intro-text {
          background-color: #fff;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          margin-bottom: 30px;
          line-height: 1.6;
        }
        
        .loading {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 200px;
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          font-size: 18px;
          color: #555;
        }
      `}</style>
    </div>
  );
};

export default SimilarityFinderPage; 